/** The URL parameter name used for frontend version overrides */
export const FRONTEND_VERSION_PARAM = 'frontend-version';

/** The required length for a valid frontend version identifier */
export const FRONTEND_VERSION_LENGTH = 9;
